import { render, staticRenderFns } from "./DocumentosProposta.vue?vue&type=template&id=f410b6bc&scoped=true"
import script from "./DocumentosProposta.vue?vue&type=script&lang=js"
export * from "./DocumentosProposta.vue?vue&type=script&lang=js"
import style0 from "./DocumentosProposta.vue?vue&type=style&index=0&id=f410b6bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f410b6bc",
  null
  
)

export default component.exports